/* TCFJ homepage 2026 — hero slider, look carousel, rails */
(function () {
  if (window.__tcfj) return; window.__tcfj = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var slides = root.querySelectorAll('.tcfj-slide');
    var tabs = root.querySelectorAll('.tcfj-tab');
    var feats = root.querySelectorAll('.tcfj-feat');
    var n = slides.length, i = 0, timer = null;
    var dur = parseInt(root.dataset.interval || '6', 10) * 1000;
    var auto = root.dataset.autoplay === 'true' && !reduce && n > 1;
    root.style.setProperty('--dur', dur / 1000 + 's');
    function show(k) {
      i = (k + n) % n;
      [slides, tabs, feats].forEach(function (list) {
        list.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
      });
      slides.forEach(function (el, j) { el.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
      tabs.forEach(function (el, j) { el.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      restart();
    }
    function restart() {
      clearTimeout(timer);
      if (!auto || root.dataset.paused) { root.classList.remove('is-playing'); return; }
      root.classList.remove('is-playing'); void root.offsetWidth; root.classList.add('is-playing');
      timer = setTimeout(function () { show(i + 1); }, dur);
    }
    tabs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
    var stage = root.querySelector('.tcfj-hero__stage');
    stage.addEventListener('mouseenter', function () { root.dataset.paused = '1'; restart(); });
    stage.addEventListener('mouseleave', function () { delete root.dataset.paused; restart(); });
    root.addEventListener('focusin', function () { root.dataset.paused = '1'; restart(); });
    // swipe on touch
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
    });
    // theme editor: jump to the selected slide
    root.addEventListener('shopify:block:select', function (e) {
      var k = Array.prototype.indexOf.call(slides, e.target);
      if (k > -1) { root.dataset.paused = '1'; show(k); }
    });
    show(0);
  }

  function initLooks(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var track = root.querySelector('.tcfj-looks__track');
    var looks = root.querySelectorAll('.tcfj-look');
    var dots = root.querySelectorAll('.tcfj-dots button');
    var count = root.querySelector('.tcfj-count');
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var n = looks.length, i = 0;
    function show(k) {
      i = Math.max(0, Math.min(n - 1, k));
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      looks.forEach(function (el, j) { el.setAttribute('aria-hidden', j === i ? 'false' : 'true'); el.inert = j !== i; });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      if (count) count.textContent = (i + 1) + ' of ' + n;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
    }
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
    root.addEventListener('shopify:block:select', function (e) {
      var k = Array.prototype.indexOf.call(looks, e.target); if (k > -1) show(k);
    });
    show(0);
  }

  function initRail(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var rail = root.querySelector('.tcfj-rail');
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (!rail) return;
    function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : 300; }
    function sync() {
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  // Quick add (single-variant products) and "add the look"
  function addItems(items, btn) {
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        btn.textContent = 'Added';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        });
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
      })
      .catch(function (e) { btn.textContent = (e && e.description) ? 'Unavailable' : 'Try again'; btn.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tcfj-add]');
    if (!b) return;
    e.preventDefault();
    var ids = b.getAttribute('data-tcfj-add').split(',').filter(Boolean);
    addItems(ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }), b);
  });


  /* ---------- Collection: filters, sort, quick add, show more ---------- */
  function initColl(root) {
    if (root.__tcfj) return; root.__tcfj = true;
    var form = root.querySelector('[data-tcfj-filter-form]');
    var refine = root.querySelector('[data-tcfj-refine]');
    var openBtn = root.querySelector('[data-tcfj-filter-open]');
    var sid = root.getAttribute('data-section');
    function setOpen(on) {
      if (!refine) return;
      refine.hidden = !on; openBtn && openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (window.matchMedia('(max-width:749px)').matches) document.body.classList.toggle('tcfj-lock', on);
      if (on) { var f = refine.querySelector('summary'); f && f.focus(); } else if (openBtn) openBtn.focus();
    }
    openBtn && openBtn.addEventListener('click', function () { setOpen(refine.hidden); });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-tcfj-filter-close]')) { e.preventDefault(); setOpen(false); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && refine && !refine.hidden) setOpen(false); });
    document.addEventListener('click', function (e) {
      if (!refine || refine.hidden || window.matchMedia('(max-width:749px)').matches) return;
      if (!e.target.closest('.tcfj-refine__panel') && !e.target.closest('[data-tcfj-filter-open]')) setOpen(false);
    });
    function query() {
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      return p.toString();
    }
    var t, go = root.querySelector('[data-tcfj-filter-go]');
    if (form) form.addEventListener('change', function (e) {
      if (e.target.matches('[data-tcfj-sort]')) { location.href = form.action + '?' + query(); return; }
      if (!go) return;
      clearTimeout(t);
      t = setTimeout(function () {
        go.disabled = true;
        fetch(form.action + '?' + query() + '&section_id=' + sid).then(function (r) { return r.text(); }).then(function (h) {
          var m = h.match(/data-tcfj-count="(\d+)"/), n = m ? +m[1] : 0;
          go.textContent = n ? 'Show ' + n + (n === 1 ? ' piece' : ' pieces') : 'No matches, try fewer filters';
          go.disabled = !n;
        }).catch(function () { go.disabled = false; });
      }, 250);
    });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); location.href = form.action + '?' + query(); });
    // Show more appends the next page in place; the link still works without script
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tcfj-more-btn]'); if (!b) return;
      e.preventDefault(); var label = b.textContent; b.textContent = 'Loading'; b.setAttribute('aria-busy', 'true');
      var u = b.getAttribute('href'); u += (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid;
      fetch(u).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var grid = root.querySelector('[data-tcfj-grid]'), first = null;
        doc.querySelectorAll('[data-tcfj-grid] > *').forEach(function (c) { var n = document.importNode(c, true); grid.appendChild(n); first = first || n; });
        var shown = grid.children.length, total = +b.getAttribute('data-total');
        root.querySelector('[data-tcfj-shown]').textContent = shown;
        root.querySelector('[data-tcfj-bar]').style.width = Math.round(shown / total * 100) + '%';
        var nb = doc.querySelector('[data-tcfj-more-btn]');
        if (nb) { b.setAttribute('href', nb.getAttribute('href')); b.textContent = label; b.removeAttribute('aria-busy'); } else b.remove();
        var prev = root.querySelector('.tcfj-more__prev'); prev && prev.remove();
        window.TCFJFav && window.TCFJFav.paint();
        var fl = first && first.querySelector('a'); fl && fl.focus({ preventScroll: true });
      }).catch(function () { location.href = b.getAttribute('href'); });
    });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tcfj-quick-open]'); if (!o) return;
    var pick = o.parentNode.querySelector('.tcfj-quickpick');
    var on = pick.hidden; pick.hidden = !on; o.hidden = on; o.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) pick.querySelector('select').focus();
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-tcfj-quick-select]'); if (!s) return;
    s.parentNode.querySelector('[data-tcfj-add]').setAttribute('data-tcfj-add', s.value);
  });

  /* ---------- Product page: gallery and variant picker ---------- */
  function initPdp(root) {
    if (root.__tcfj) return; root.__tcfj = true;
    var track = root.querySelector('[data-tcfj-track]');
    var thumbs = root.querySelectorAll('[data-tcfj-thumb]');
    function goTo(i) { if (!track) return; track.scrollTo({ left: track.clientWidth * i }); }
    function mark(i) { thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-on', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = +t.getAttribute('data-tcfj-thumb'); goTo(i); mark(i); }); });
    if (track) {
      var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        var i = Math.round(track.scrollLeft / track.clientWidth), n = track.children.length;
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(n - 1, i + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, i - 1)); }
      });
    }
    var dataEl = root.querySelector('[data-tcfj-variants]'); if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('[data-tcfj-pdp-form]');
    var idInput = root.querySelector('[data-tcfj-variant-id]');
    var priceEl = root.querySelector('[data-tcfj-price]');
    var addBtn = root.querySelector('[data-tcfj-pdp-add]');
    var added = root.querySelector('[data-tcfj-added]');
    var sets = root.querySelectorAll('[data-tcfj-opt]');
    function chosen() { var a = []; sets.forEach(function (f) { var c = f.querySelector('input[type=radio]:checked'); a.push(c ? c.value : null); }); return a; }
    function find(opts) { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }
    function update(fromUser) {
      var opts = chosen(), v = find(opts);
      sets.forEach(function (f, i) {
        var c = f.querySelector('input:checked'); f.querySelector('[data-tcfj-opt-sel]').textContent = c ? c.getAttribute('data-label') : '';
        f.querySelectorAll('input[type=radio]').forEach(function (r) {
          var t = opts.slice(); t[i] = r.value; var m = find(t);
          r.classList.toggle('is-na', !m || !m.available);
        });
        var cu = f.querySelector('[data-tcfj-custom]');
        if (cu) { var isC = c && /custom/i.test(c.value); cu.hidden = !isC; cu.querySelector('input').disabled = !isC; cu.querySelector('input').required = !!isC; }
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable in this combination'; return; }
      idInput.value = v.id;
      priceEl.textContent = v.price;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to bag, ' + v.price : 'Sold out';
      if (fromUser) {
        try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
        if (v.media && track) {
          var sl = track.querySelector('[data-media-id="' + v.media + '"]');
          if (sl) { var i = Array.prototype.indexOf.call(track.children, sl); goTo(i); mark(i); }
        }
      }
    }
    sets.forEach(function (f) { f.addEventListener('change', function () { update(true); }); });
    update(false);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      var label = addBtn.textContent; addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: (function () { var fd = new FormData(form); Array.from(fd.keys()).forEach(function (k) { if (k.indexOf('tcfj-opt') === 0) fd.delete(k); }); return fd; })() })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          addBtn.textContent = 'Added'; added.hidden = false;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          });
          setTimeout(function () { addBtn.textContent = label; addBtn.disabled = false; }, 2200);
        })
        .catch(function (err) { addBtn.textContent = (err && err.description) ? err.description : 'Try again'; setTimeout(function () { addBtn.textContent = label; addBtn.disabled = false; }, 3000); });
    });
  }
  function boot(scope) {
    (scope || document).querySelectorAll('[data-tcfj-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-tcfj-looks]').forEach(initLooks);
    (scope || document).querySelectorAll('[data-tcfj-rail]').forEach(initRail);
    (scope || document).querySelectorAll('[data-tcfj-coll]').forEach(initColl);
    (scope || document).querySelectorAll('[data-tcfj-pdp]').forEach(initPdp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
